import { Content } from '../../../models/Content/Content.js';
import { PriceMapper } from '../../../models/Price/PriceMapper.js';

class Price {
  constructor(apiClient) {
    this.apiClient = apiClient;
  }
  get(from, to, parcel, service, content, insurance, voucher, cod, priority) {
    return this.apiClient.post('com/shipments/price', {
      content: content ? content.getCreatePayload() : Content.deserialize({}).getCreatePayload(),
      from: from.getCreatePayload(),
      insurance: !!insurance,
      packages: parcel.map(item => {
        const {
          height,
          length,
          weight,
          width
        } = item;
        return {
          height,
          length,
          weight,
          width
        };
      }),
      service_id: service.id,
      to: to.getCreatePayload(),
      ...(cod && {
        cash_on_delivery_amount: cod === null || cod === void 0 ? void 0 : cod.amount
      }),
      ...(voucher && {
        voucher_name: voucher === null || voucher === void 0 ? void 0 : voucher.name
      }),
      priority
    }).then(response => PriceMapper.createModelFromResponse(response.data));
  }
}

export { Price };
//# sourceMappingURL=Price.js.map
